module.exports = __webpack_public_path__ + "img/water-pump.110673b6.png";